import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Offerings } from './pages/Offerings';
import { Contact } from './pages/Contact';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsPage } from './pages/TermsPage';
import { RefundPolicyPage } from './pages/RefundPolicyPage';
import { DigitalDeliveryPolicyPage } from './pages/DigitalDeliveryPolicyPage';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31b8lg3ugklbu">
      <Routes data-id="element-1" data-mp="31brz38d2snk2">
        <Route element={<Layout data-id="element-3" data-mp="31ctdnmtavs6j" />} data-id="element-2" data-mp="31c9uk2rwyxqx">
          <Route path="/" element={<Home data-id="element-5" data-mp="2wjqi594yq8np" />} data-id="element-4" data-mp="2wk0bn6p7uxy5" />
          <Route path="/about" element={<About data-id="element-7" data-mp="2whx95n6vnccj" />} data-id="element-6" data-mp="2wj8dbo48im46" />
          <Route path="/what-we-offer" element={<Offerings data-id="element-9" data-mp="28te2fc3h77mk" />} data-id="element-8" data-mp="28ufoebm15ej2" />
          <Route path="/contact" element={<Contact data-id="element-11" data-mp="23vchsmqej08z" />} data-id="element-10" data-mp="28sl48zil1qg1" />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-13" data-mp="23v2rey1g2r2r" />} data-id="element-12" data-mp="23w4fc33k781w" />
          <Route path="/terms-and-conditions" element={<TermsPage data-id="element-15" data-mp="3ij64oawq3n8e" />} data-id="element-14" data-mp="3ijxokogyjwiu" />
          <Route path="/refund-policy" element={<RefundPolicyPage data-id="element-17" data-mp="3mlaxj7fckftz" />} data-id="element-16" data-mp="3ijpef4c7z5bc" />
          <Route path="/digital-delivery-policy" element={<DigitalDeliveryPolicyPage data-id="element-19" data-mp="3rbrayrj641gc" />} data-id="element-18" data-mp="3mk85uxa7a9d0" />
          <Route path="*" element={<NotFound data-id="element-21" data-mp="5yj0slx59ec" />} data-id="element-20" data-mp="3rd189ei755lx" />
        </Route>
      </Routes>
    </BrowserRouter>;
}